/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormAnswerFromJSON, FormAnswerToJSON, } from './FormAnswer';
/**
 * Check if a given object implements the FormQuestion interface.
 */
export function instanceOfFormQuestion(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isUserInput' in value) || value['isUserInput'] === undefined)
        return false;
    if (!('answers' in value) || value['answers'] === undefined)
        return false;
    return true;
}
export function FormQuestionFromJSON(json) {
    return FormQuestionFromJSONTyped(json, false);
}
export function FormQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'isUserInput': json['isUserInput'],
        'answers': (json['answers'].map(FormAnswerFromJSON)),
    };
}
export function FormQuestionToJSON(json) {
    return FormQuestionToJSONTyped(json, false);
}
export function FormQuestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'isUserInput': value['isUserInput'],
        'answers': (value['answers'].map(FormAnswerToJSON)),
    };
}
